import find from 'lodash/find';
import _debounce from 'lodash/debounce';

export default class AddStudentController {
  /** @ngInject */
  constructor(
    $log, $scope, $mdDialog, $mdToast,
    StudentService
  ) {
    this.$log = $log;
    this.$scope = $scope;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.StudentService = StudentService;

    this.student = {};
    this.loadPageCallbackWithDebounce = {};
  }

  changeFilter() {
    if (this.loadPageCallbackWithDebounce) {
      this.loadPageCallbackWithDebounce();
    }
  }

  getLoadResultsCallback(loadPageCallback) {
    this.loadPageCallbackWithDebounce = _debounce(loadPageCallback, 1000);
  }

  paginatorCallback(page, pageSize) {
    let offset = (page - 1) * pageSize;
    if (angular.isUndefined(offset)) {
      offset = 0;
    }

    const query = this.filterName ? this.filterName : '';
    return this.StudentService.getAll({
      offset,
      limit: pageSize,
      query
    }).then(result => {
      this.students = result.data.students;
      return {
        results: result.data.students,
        totalResultCount: result.data.total
      };
    });
  }

  add(id) {
    this.student = this.getStudentById(this.students, id);
    this.$mdDialog.hide(this.student);
  }

  getStudentById(list, id) {
    return find(list, item => {
      if (item.id === id) {
        return item;
      }
    });
  }

  cancel() {
    this.$mdDialog.cancel();
  }
}
